module.exports = __webpack_public_path__ + "img/15_56.acaadf34.png";